import React, { FC } from 'react';
import { StyleSheetManager } from 'styled-components';
import { ThemeType } from '../theme/headerCustomTheme';
import { Theme } from '../theme';

type Props = {
    theme: ThemeType;
    scope: string;
    children: React.ReactNode;
};

const createExtraScopePlugin = (scope: string) => {
    const plugin = (context: number, content: string[], selectors: string[]) => {
        if (context === -1) {
            for (let i = 0; i < selectors.length; i++) {
                const selector = selectors[i];
                if (/^\.[\w-]+$/i.test(selector)) {
                    /* We repeat the class name twice because otherwise
                       styled-components is going to replace dynamic
                       classes with the full component class instead */
                    // eslint-disable-next-line no-param-reassign
                    selectors[i] = `${scope} ${selector.repeat(2)}`;
                }
            }
        }
    };

    // Styled-components require the function to have a name
    Object.defineProperty(plugin, 'name', { value: `scope-${scope}` });

    return plugin;
};

const ScopedStyleProvider: FC<Props> = ({ theme, scope, children }) => {
    const stylisPlugins = scope ? [createExtraScopePlugin(`#${scope}`)] : [];

    return (
        <StyleSheetManager stylisPlugins={stylisPlugins}>
            <Theme theme={theme}>{children}</Theme>
        </StyleSheetManager>
    );
};
export default ScopedStyleProvider;
